import styled, { css } from "styled-components";
import { theme } from "twin.macro";

import { SPACE } from "../LayoutTokens";

export const StyledMedia = styled.div<{ $bordered: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${SPACE.sm};
  width: 100%;

  .c-media-frame {
    ${({ $bordered }) =>
      $bordered &&
      css`
        overflow: hidden;
        border: 1px solid var(--border-primary);
        border-radius: ${theme("borderRadius.lg")};
      `}
  }

  .c-media-frame img {
    display: block;
    width: 100%;
    height: auto;
  }
`;

StyledMedia.displayName = "StyledMedia";
